import { FC } from 'react';

const IllustrationSearchError: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    fill="none"
    viewBox="0 0 80 80"
  >
    <path
      fill="#1D1D1D"
      fillRule="evenodd"
      d="M55.415 59.521a28.92 28.92 0 0 1-18.377 6.554C21 66.075 8 53.075 8 37.038S21 8 37.038 8c16.037 0 29.037 13 29.037 29.038a28.92 28.92 0 0 1-6.554 18.377L72 67.894 67.894 72zm4.853-22.483c0 12.83-10.4 23.23-23.23 23.23s-23.23-10.4-23.23-23.23 10.4-23.23 23.23-23.23 23.23 10.4 23.23 23.23"
      clipRule="evenodd"
    ></path>
    <path
      fill="#E81741"
      fillRule="evenodd"
      d="M32 54c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13m-1.6-11.4L30 33h4l-.4 9.6zM32 49a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default IllustrationSearchError;
